import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(Backend)
    .use(LanguageDetector) // detects the current language
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        fallbackLng: 'ua', // default language
        returnEmptyString: false,
        detection: {
            checkWhitelist: true,
        },
        debug: false,
    });
 const waitForInstance =  (key) => {
    return i18n.loadLanguages(["en","ua"]).then(
        () => {
            return i18n.t(key)
        }
    )
}

export const getTranslation = async (key) => {
    const trans = await waitForInstance(key)
    return await waitForInstance(key)
}

export default i18n;